// ENG-SOT-050 — shared, dependency-free pieces of the intake contract, safe to import from the browser form
// and from the server module alike (no node builtins).

/** Shape of a durable downstream case id. The same pattern gates the server's receipt check and the form's success state. */
export const CASE_ID_RE = /^[A-Za-z0-9][A-Za-z0-9_-]{5,63}$/;

/** Shown for ANY failure that cannot prove nothing was persisted (timeout, dropped connection, 5xx, malformed receipt). */
export const UNCONFIRMED_MESSAGE =
  "We couldn't confirm that your message was delivered, so it may or may not have been received. Your text is still in the form. You can submit it again as it is: a repeat of the same message will not create a second case.";

export type FormOutcome =
  | { kind: "success"; caseId: string }
  | { kind: "failure"; message: string; fields?: Record<string, string> };

/** Turns the /api/feedback response into what the form may show. Success requires a well-formed case id; anything else keeps the input. */
export function outcomeFromResponse(httpOk: boolean, json: unknown): FormOutcome {
  const j = (json && typeof json === "object" ? json : {}) as { ok?: unknown; caseId?: unknown; error?: unknown; fields?: unknown };
  if (httpOk && j.ok === true && typeof j.caseId === "string" && CASE_ID_RE.test(j.caseId)) return { kind: "success", caseId: j.caseId };
  const fields = j.fields && typeof j.fields === "object" ? (j.fields as Record<string, string>) : undefined;
  // A non-2xx response that carries its own message (validation, rate limit, size, intake status) is shown as sent;
  // a 2xx that is not a valid receipt, or a body we cannot read, is "unconfirmed" — never "received".
  const message = !httpOk && typeof j.error === "string" && j.error ? j.error : UNCONFIRMED_MESSAGE;
  return { kind: "failure", message, ...(fields ? { fields } : {}) };
}
